import { render, staticRenderFns } from "./HotelsMapCard.vue?vue&type=template&id=5b4efb17"
import script from "./HotelsMapCard.vue?vue&type=script&lang=js"
export * from "./HotelsMapCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsCarousel: require('/home/forge/ab.farescraper.com/components/HotelsCarousel.vue').default})
